<div class="container">
  <div class="header">
    <img class="header-image" src="assets/img/HOME-SOLIARRIENDO.png" alt="Soliarriendo">
    <svg class="wave" viewBox="0 0 1440 320">
      <path fill="#FFFFFF" d="M0,240L40,245C80,248,160,252,240,255C320,258,400,260,480,260C560,260,640,258,720,255C800,252,880,240,960,230C1040,220,1120,217,1200,215C1280,213,1360,217,1400,220L1440,220L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path>
    </svg>
    <app-modal></app-modal>
    <app-charging></app-charging>
  </div>

  <!-- Busqueda de numero de Cotizacion -->
  <div class="content" *ngIf="processStep === 1">
    <div class="input-container">
      <label for="quotationNumber">Número de Cotización *</label>
      <div class="search-bar">
        <input type="number" id="quotationNumber" placeholder="Digite el número de cotización"[(ngModel)]="quotationNumber" (input)="onFindQuotationInputChange()" onkeydown="return !['e', 'E', '-', '+'].includes(event.key)">
        <button class="find-quote-button" [disabled]="isFindQuotationButtonDisabled" (click)="onFindQuote()">
          <i class="fas fa-search search-icon"></i>
        </button>
      </div>
    </div>
    <a class="forgot-quotation" (click)="processStep = 6">Olvidé mi número de cotización</a>
  </div>

  <!-- Informacion -->
  <div class="content info-content" *ngIf="processStep === 2">
    <div *ngIf="procesoContinua; then content else other_content"></div>
      <ng-template #content>
        <p class="text">Actualmente nuestro proceso de radicación en linea se encuentra disponible con la siguiente cobertura:</p>
        <p class="text-bold">Departamento: {{ departamento | titlecase }}, Ciudad/Municipio: {{ municipio | titlecase }}</p>
        <table class="tabla-sucursales">
          <thead>
            <tr>
              <th class="text">Sucursales disponibles para su acompañamiento </th>
            </tr>
          </thead>

          <tbody>

            <!-- Código original dinámico que recorre la lista de sucursales.
            Si en el futuro desea volver a pintar la lista desde el array "sucursales",
            solo debe descomentar esta sección y comentar o eliminar la versión quemada. -->
            
            <tr *ngFor="let sucursal of sucursales">
              <td class="text">
                {{ sucursal.strBranchOfficeName }},
                <span class="small-text">{{ sucursal.strBranchOfficeAdress }}</span>
              </td>
            </tr>
          
            <!-- Primera sucursal quemada -->
            <!-- <tr>
              <td class="text">
                BOGOTÁ DIRECCIÓN GENERAL,
                <span class="small-text">CALLE 100 9 A 45 P 12</span>
              </td>
            </tr> -->
          
            <!-- Segunda sucursal quemada -->
            <!-- <tr>
              <td class="text">
                SEAS BOGOTÁ FÁCIL SEGUROS LTDA,
                <span class="small-text">CALLE 53 NO. 27 A - 60 OFC. 202</span>
              </td>
            </tr>
          </tbody> -->
          
        </table>
        <p class="text">
          Si tu inmueble se encuentra dentro de este rango de cobertura, puedes continuar con el proceso, de lo contrario puedes contactarte con nosotros
          a traves del <b><a href="tel:789" style="color:#003f75; text-decoration:none;">#789</a></b> o el siguiente
          <a [href]="LinkUrl" target="_blank" style="color:#003f75; text-decoration:none;"><b>Link</b></a>
           en nuestro portal de producto, donde podras dejar tus datos para ser contactado por unos de nuestros ejecutivos de cuenta.
        </p>
      </ng-template>
      <ng-template #other_content>
        <p class="text">Tu inmueble no se encuentra dentro de rango de cobertura, para continuar con en el proceso de radicación en linea.</p>
        <p class="text">
          Puedes contactarte con nosotros a traves del <b><a href="tel:789" style="color:#003f75; text-decoration:none;">#789</a></b>
          o el siguiente <a [href]="LinkUrl" target="_blank" style="color:#003f75; text-decoration:none;"><b>Link</b></a>
          en nuestro portal de producto, donde podras dejar tus datos para ser contactado por unos de nuestros ejecutivos de cuenta.
        </p>
      </ng-template>
      <p class="text text-center text-bold" *ngIf="isLinked">
        Bienvenido, su rol en el proceso es {{getRoleText()}}
      </p>
      <button class="continue-button" 
      (click)="isLinked ? onContinueToHome() : onSendEmail()">
      Continuar
      </button>
  </div>

  <!-- Ingreso codigo de seguridad -->
  <div class="content" *ngIf="processStep === 3">
    <div class="input-container">
      <label for="securityCode">Código de Seguridad *</label>
      <div class="code-inputs">
        <input
        type="text"
        maxlength="1"
        class="code-box"
        [(ngModel)]="securityCode[0]"
        (input)="onSecurityCodeInput($event, 1)"
        (keydown)="onSecurityCodeKeyDown($event, 1)"
      />
      <input
        type="text"
        maxlength="1"
        class="code-box"
        [(ngModel)]="securityCode[1]"
        (input)="onSecurityCodeInput($event, 2)"
        (keydown)="onSecurityCodeKeyDown($event, 2)"
      />
      <input
        type="text"
        maxlength="1"
        class="code-box"
        [(ngModel)]="securityCode[2]"
        (input)="onSecurityCodeInput($event, 3)"
        (keydown)="onSecurityCodeKeyDown($event, 3)"
      />
      <input
        type="text"
        maxlength="1"
        class="code-box"
        [(ngModel)]="securityCode[3]"
        (input)="onSecurityCodeInput($event, 4)"
        (keydown)="onSecurityCodeKeyDown($event, 4)"
      />
      </div>

      <hr class="separator" />
      <p class="code-message">Digite el código de seguridad</p>

      <button class="verify-button" (click)="verifyCode()" [disabled]="!isCodeComplete">Validar</button>
    </div>
  </div>

  <!-- Selección de rol principal -->
  <div class="content" *ngIf="processStep === 4">
    <div class="input-container">
      <p class="text text-center">
        Para continuar con el proceso de arrendamiento, seleccione el rol que usted desempeñará como responsable principal.
      </p>
      
      <label for="roleSelection">Seleccione su rol *</label>
      <div class="radio-group">
        <label>
          <input type="radio" name="role" (change)="onUserRolChange(2)" />
          Propietario
        </label>
        <label>
          <input type="radio" name="role" (change)="onUserRolChange(1)" />
          Arrendatario
        </label>
      </div>
      
      <p class="text-bold">
        En la cotización su rol es {{ quoteRol == 2 ? 'Propietario' : 'Arrendatario' }}
      </p>
      
      <button class="continue-button" 
        [disabled]="loginRole === null" 
        (click)="onContinueToHome()">    
        Continuar
      </button>
    </div>
  </div>

    <!-- Olvide contraseña -->
    <div class="content" *ngIf="processStep === 6">
      <div class="input-container">
        <label for="roleSelection">Realizar busqueda por *</label>
        <p class="text-bold">Seleccione la opción para realizar la busqueda de la cotización</p>
        <div class="radio-group">
          <label>
            <input type="radio" name="role" (change)="recoveryMethod = 1" [checked]="recoveryMethod === 1" />
            Correo Electrónico
          </label>
          <label>
            <input type="radio" name="role" (change)="recoveryMethod = 2" [checked]="recoveryMethod === 2" />
            Número Celular
          </label>
        </div>
        <button class="continue-button" [disabled]="recoveryMethod === null" (click)="onRecoveryMethodSelected()">
          Continuar
        </button>
        <a class="forgot-quotation" (click)="processStep = 1">Recorde mi número de cotización</a>
      </div>
    </div>

    <!-- Olvide contraseña p2 -->
    <div class="content" *ngIf="processStep === 7">
      <div class="input-container">
        <label>{{ recoveryMethod === 1 ? 'Correo Electrónico *' : 'Número Celular *' }}</label>
        <p class="text-bold">
          Digite el {{ recoveryMethod === 1 ? 'correo electrónico' : 'número de celular' }} que ingresó en la cotización
        </p>
        <div class="search-bar">
          <input
            [type]="recoveryMethod === 1 ? 'email' : 'number'"
            id="recoveryValue"
            placeholder="Digite el {{ recoveryMethod === 1 ? 'correo electrónico' : 'número de celular' }}"
            [(ngModel)]="recoveryValue"
            (input)="onFindQuotationHeaderByOwner()">
          <button class="find-quote-button" [disabled]="isForgotQuotationButtonDisabled" (click)="onFindQuoteByOwner()">
            <i class="fas fa-search search-icon"></i>
          </button>
        </div>
      </div>
      <a class="forgot-quotation" (click)="processStep = 1; recoveryValue = null">Recorde mi número de cotización</a>
    </div>

    <!-- Continuar si ya esta definido el rol principal del proceso-->
    <div class="content info-content" *ngIf="processStep === 8">
      <p class="text text-center text-bold">Bienvenido, continue su proceso</p>
      <button class="continue-button" 
      [disabled]="loginRole === null" 
      (click)="onContinueToHome()">    
        Continuar
      </button>
    </div>
</div>